import { Component } from 'react';
import WX_SDK from 'weixin-js-sdk';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { isIOS } from '../../utils/tools';

import { getWxShareInfo } from '../../service/chat-service';

// const noop = () => {};

const propTypes = {
  desc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
  // onShareSuccess: PropTypes.func
};

const defaultProps = {
  // onShareSuccess: noop
};

/**
 * 微信分享
 */
class WXShare extends Component {
  componentDidMount() {
    if (isIOS() && window.location.pathname.indexOf('liveRegistration') > -1) {
      this.WXInit();
    } else {
      this.WXInit(); // ios 解决分享bug
    }
  }

  WXInit = async () => {
    const url = window.location.href;

    try {
      const WXConfig = await getWxShareInfo(url);
      WXConfig.jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData'];
      WXConfig.appId = WXConfig.appid;

      WXConfig.debug = false;

      WX_SDK.config(WXConfig);
      WX_SDK.ready(this.setWXShare);
    } catch (e) {
      // console.log(e);
    }
  }

  /**
   * 微信分享设置
   */
  setWXShare = () => {
    const {
      desc, title, imgUrl, link,
    } = this.props;
    // 分享到好友
    WX_SDK.updateAppMessageShareData({
      title,
      desc,
      link,
      imgUrl,
      success() {
        // onShareSuccess(SHARE_TYPE.FRIEND)
      },
    });

    // 分享到朋友圈
    WX_SDK.updateTimelineShareData({
      title,
      link,
      imgUrl,
      success() {
        // 设置成功
        // onShareSuccess(SHARE_TYPE.CIRCLE)
      },
    });
  }

  render() {
    return null;
  }
}

WXShare.propTypes = propTypes;
WXShare.defaultProps = defaultProps;

export default withRouter(WXShare);
